"use strict";
function t(n) {
  return function(u) {
    return n.apply(null, u);
  };
}
export {
  t as default
};
//# sourceMappingURL=index.es131.js.map
